<template>
  <div class="flex flex-wrap -mx-2">
    <div class="w-full md:w-1/2 px-2 mb-4">
      <img :src="block.form.image.url" alt class="cursor-pointer" />
      <div
        v-if="block.form.caption"
        class="text-center text-gray-600 mt-2 text-sm"
      >{{ block.form.caption }}</div>
    </div>
    <div class="w-full md:w-1/2 px-2 mb-4">
      <div class="text-justify text-sm basic">
        <div v-html="block.form.text"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    block: {}
  }
}
</script>

<style lang="scss" scoped></style>
